import { PaperclipIcon } from "lucide-react";
import { useRef } from "react";

import { Button } from "@/components/button";
import { useEditRequestModals } from "@/features/request/edit/contexts/edit-request-modals.context";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";

interface FileUploadButtonProps {
  isUploadDisabled?: boolean;
  onFilesSelected: (files: File[]) => void;
}

export function FileUploadButton({
  isUploadDisabled = false,
  onFilesSelected,
}: FileUploadButtonProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { isTemplate } = useIsTemplate();
  const { openUnlock } = useEditRequestModals();

  const handleButtonClick = () => {
    if (isTemplate) {
      openUnlock();

      return;
    }
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;

    if (fileList && fileList.length > 0) {
      const filesArray = [...fileList];

      onFilesSelected(filesArray);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  return (
    <>
      <Button
        className="border border-border-primary text-button-secondary-fg w-[48px] h-[48px]"
        isDisabled={isUploadDisabled}
        onPress={handleButtonClick}
        variant="plain"
      >
        <PaperclipIcon className="w-4 h-4" />
      </Button>
      <input
        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
        className="hidden"
        multiple
        onChange={handleFileChange}
        ref={fileInputRef}
        type="file"
      />
    </>
  );
}
